import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { loadableIzSearchesAtom, isHydrated } from "../../jotai/atoms";
import { SearchStatus } from "../../models/Interfaces";

export const MobileFooterTab = {
  SEARCH: "SEARCH",
  RECORDS: "RECORDS",
} as const;
export type MobileFooterTab = typeof MobileFooterTab[keyof typeof MobileFooterTab];

export default function MobileFooter({
  onTabChange,
}: {
  onTabChange: (tab: MobileFooterTab) => void;
}) {
  const navigate = useNavigate();
  const [allSearches] = useAtom(loadableIzSearchesAtom);
  const hasVerificationNeeded = React.useMemo(() => {
    if (allSearches.state !== "hasData" || !isHydrated(allSearches.data)) {
      return false;
    }

    return allSearches.data.some(
      (search) =>
        search.status.trim() === SearchStatus.partialMatchAltContacts && !search.dateVerified
    );
  }, [allSearches]);

  const onSearchClick = () => {
    onTabChange(MobileFooterTab.SEARCH);
    navigate("/home/search");
  };

  const onRecordsClick = () => {
    onTabChange(MobileFooterTab.RECORDS);
    navigate("/home/records");
  };

  return (
    <div
      data-testid="mobile-footer"
      className="fixed inset-x-0 bottom-0 md:hidden flex bg-blue-950 w-full h-20 pb-4"
    >
      <div className="flex items-center w-1/2 justify-center" onClick={onSearchClick}>
        <p
          className="text-white font-bold"
          style={{ color: location?.pathname.includes("/home/search") ? "#EBBE4D" : "" }}
        >
          Search
        </p>
        {hasVerificationNeeded && (
          <img
            src="/assets/images/yellow_status.png"
            className="w-[12px] h-[12px] mb-[10px]"
            data-testid="verification-needed-icon"
          />
        )}
      </div>
      <div className="flex items-center w-1/2 justify-center" onClick={onRecordsClick}>
        <p
          className="text-white font-bold"
          style={{ color: location?.pathname.includes("/home/records") ? "#EBBE4D" : "" }}
        >
          Records
        </p>
      </div>
    </div>
  );
}
